import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import { toast } from "react-toastify";
import { FaHome } from "react-icons/fa"; // Optional: if you want to keep an icon inside the header
import { useAuth } from "../context/AuthContext";
import "./ResendConfirmationPage.css";

const ResendConfirmationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { handleLogout } = useAuth();
  const [email, setEmail] = useState(location.state?.email || "");
  const [isLoading, setIsLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [showLoginOption, setShowLoginOption] = useState(false);

  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    }
  }, [location.state]);

  const handleResendEmail = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatusMessage("");
    setShowLoginOption(false);

    try {
      const response = await axiosInstance.post("/auth/resend-confirmation", { email });
      if (response.status === 200) {
        setStatusMessage(response.data.message || "Confirmation email resent successfully.");
        // Optionally, redirect after a brief delay.
        setTimeout(() => navigate("/login", { replace: true }), 2000);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "An error occurred. Please try again.";
      setStatusMessage(errorMessage);
      // If the error indicates the email is already confirmed, show the login option.
      if (error.response?.data?.message === "Email is already confirmed.") {
        setShowLoginOption(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Function to log out and navigate to the login page.
  const handleLoginClick = () => {
    handleLogout(); // Clears auth state, tokens, etc.
    navigate("/login", { replace: true });
  };

  return (
    <div className="resend-confirmation-container">
      <div className="resend-confirmation-box">
        <header className="app-header">
          <h2 className="app-name">
            <span className="dot">N</span>netego HMS<span className="dot">.</span>
          </h2>
          <p className="app-tagline">Confirm Your Email</p>
        </header>

        {statusMessage && <p className="status-message">{statusMessage}</p>}

        {showLoginOption ? (
          <button onClick={handleLoginClick} className="action-button">
            Go to Login
          </button>
        ) : (
          <form onSubmit={handleResendEmail} className="resend-form">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
              className="input-field"
            />
            <button type="submit" disabled={isLoading} className="action-button">
              {isLoading ? "Resending..." : "Resend Email"}
            </button>
          </form>
        )}

        {/* Login option displayed at the bottom */}
        <div className="login-option">
          <p>Already confirmed?&nbsp;</p>
          <button onClick={handleLoginClick} className="login-button">
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResendConfirmationPage;
